import { useNavigate } from "react-router-dom";
import PaymentIcon from "@mui/icons-material/Payment";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const PLAN_BENEFITS = [
  "Full access to clinic management tools",
  "Appointments, billing & patient records",
  "Ongoing updates and priority support",
];

function ReminderModel() {
  const navigate = useNavigate();
  const handlePayNow = () => {
    navigate("/client/pay");
  };
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/55 p-4 backdrop-blur-md">
      <div
        className="relative w-full max-w-md overflow-hidden rounded-2xl border border-slate-200/60 bg-white shadow-2xl shadow-slate-900/20 dark:border-slate-700 dark:bg-slate-900"
        role="dialog"
        aria-modal="true"
        aria-labelledby="payment-reminder-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-primary via-primaryLight to-primary" />
        <div className="relative overflow-hidden bg-gradient-to-br from-primary to-primaryLight px-6 pb-8 pt-6">
          <div className="pointer-events-none absolute -right-8 -top-8 h-32 w-32 rounded-full bg-white/10" />
          <div className="pointer-events-none absolute -bottom-12 -left-6 h-24 w-24 rounded-full bg-white/5" />

          <div className="relative flex items-center gap-3">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-white/20 shadow-inner backdrop-blur-sm">
              <NotificationsActiveIcon sx={{ fontSize: 26 }} className="text-white" />
            </div>
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-wider text-white/70">
                Action required
              </p>
              <h2 id="payment-reminder-title" className="text-lg font-bold text-white">
                Payment Reminder
              </h2>
            </div>
          </div>
        </div>
        <div className="relative -mt-4 px-6">
          <div className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-amber-50 px-3 py-1.5 shadow-sm dark:border-amber-800/50 dark:bg-amber-900/30">
            <WarningAmberIcon sx={{ fontSize: 16 }} className="text-amber-600 dark:text-amber-400" />
            <span className="text-xs font-semibold text-amber-800 dark:text-amber-200">
              Subscription renewal due
            </span>
          </div>
        </div>
        <div className="space-y-4 px-6 py-5">
          <p className="text-sm font-medium text-slate-800 dark:text-slate-100">Dear User,</p>
          <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-400">
            We hope you are enjoying Care32 Dent. To continue using all features without
            interruption, please complete your subscription payment at your earliest
            convenience.
          </p>

          <div className="rounded-xl border border-slate-200/70 bg-slate-50/80 p-3.5 dark:border-slate-700 dark:bg-slate-800/50">
            <p className="mb-2.5 text-[11px] font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Active plan includes
            </p>
            <ul className="space-y-2">
              {PLAN_BENEFITS.map((item) => (
                <li
                  key={item}
                  className="flex items-start gap-2 text-xs text-slate-600 dark:text-slate-300"
                >
                  <CheckCircleOutlineIcon
                    sx={{ fontSize: 16 }}
                    className="mt-0.5 shrink-0 text-primary dark:text-primaryLight"
                  />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <p className="text-xs text-slate-500 dark:text-slate-400">
            Best regards,{" "}
            <span className="font-semibold text-primary dark:text-primaryLight">
              Care32 Dent Software
            </span>
          </p>
        </div>
        <div className="border-t border-slate-200/70 bg-slate-50/80 px-6 py-4 dark:border-slate-700 dark:bg-slate-800/50">
          <button
            type="button"
            onClick={handlePayNow}
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-primary to-primaryLight px-4 py-2.5 text-sm font-semibold text-white shadow-md shadow-primary/25 transition-all hover:shadow-lg hover:shadow-primary/30 active:scale-[0.98]"
          >
            <PaymentIcon sx={{ fontSize: 18 }} />
            Pay Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReminderModel;
